export const isCtrlKey = (ctrlKey: boolean, metaKey: boolean) => {
  const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);

  return ctrlKey || (isMac && metaKey);
};
